export const SET_APIM_TOKEN = "SET_APIM_TOKEN";
export const SET_TEAMS = "SET_TEAMS";
export const SET_MLOPS_FETCHING_FLAG = "SET_MLOPS_FETCHING_FLAG";